export const INPUT_DEBOUNCE_SUBMIT_TIME_MS = 1000
